var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 48,
    viewBox: "0 0 212 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.459 3.13905H21.165L24.2873 0H200.58V30.6302L207.583 23.6008H212L197.459 38.2069V3.13905Z",
    fill: "url(#paint0_linear_2051_39395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5413 44.8608H190.835L187.713 47.9999H11.4195V17.3697L4.41711 24.3991H0L14.5413 9.79297V44.8608Z",
    fill: "url(#paint1_linear_2051_39395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.205 14.0847L144.773 27.3783V33.9228H141.647V27.3783L133.211 14.0847H136.917L143.208 24.0018L149.503 14.0847H153.205Z",
    fill: "#5A5F72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.488 14.0736V33.9302H126.362V16.819H125.857L117.062 33.9302H111.33V14.0921H114.452V31.1882H114.96L123.752 14.0736H129.488Z",
    fill: "#5A5F72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4858 14.0847V16.8301H58.6468V33.9228H55.5211V16.8301H48.6826V14.0847H65.4858Z",
    fill: "#5A5F72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.392 23.6994H94.6364V16.8376H101.392C103.062 16.8376 104.416 18.3727 104.416 20.2685C104.416 22.1643 103.062 23.6994 101.392 23.6994ZM101.392 14.0922H94.6364V14.0847H91.5146V33.9228H94.6364V26.4414H101.392V26.4449C104.786 26.4449 107.542 23.681 107.542 20.2685C107.542 16.8596 104.786 14.0922 101.392 14.0922Z",
    fill: "#5A5F72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2564 31.6111C73.1984 31.6111 69.9093 28.2057 69.9093 24.002C69.9093 19.8018 73.1984 16.3958 77.2564 16.3958C81.3115 16.3958 84.6001 19.8018 84.6001 24.002C84.6001 28.2057 81.3115 31.6111 77.2564 31.6111ZM77.2564 13.6509C71.4739 13.6509 66.7881 18.2846 66.7881 24.002C66.7881 29.7188 71.4739 34.3565 77.2564 34.3565C83.0395 34.3565 87.7253 29.7188 87.7253 24.002C87.7253 18.2846 83.0395 13.6509 77.2564 13.6509Z",
    fill: "#5A5F72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.487 14.0736V33.9302H177.362V16.819H177.239L170.196 30.6524H167.075L160.032 16.819H159.905V33.9302H156.783V14.0736H162.337L168.636 27.2759L174.933 14.0736H180.487Z",
    fill: "#5A5F72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2841 31.1956H34.6452V24.2789H41.2841C42.954 24.2789 44.3079 25.8175 44.3079 27.7098C44.3079 29.6056 42.954 31.1956 41.2841 31.1956ZM34.6452 16.812H39.7269C40.8122 16.812 41.6904 17.8691 41.6904 19.1742C41.6904 20.4763 40.8122 21.5335 39.7269 21.5335H34.6452V16.812ZM43.8833 22.1132C44.4674 21.2821 44.8126 20.2683 44.8126 19.1742C44.8126 16.3525 42.5362 14.0665 39.7269 14.0665H31.5195V33.941H41.2841C44.6785 33.941 47.4337 31.1228 47.4337 27.7098C47.4337 25.2343 45.9813 23.0975 43.8833 22.1132Z",
    fill: "#5A5F72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2051_39395",
    x1: -127.062,
    y1: -50.235,
    x2: -80.1023,
    y2: -152.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498537,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2051_39395",
    x1: -148.227,
    y1: -40.4421,
    x2: -101.267,
    y2: -142.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498537,
    stopColor: "#69D2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68AD65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHuge);
export default __webpack_public_path__ + "static/media/logo_huge.b2064b65.svg";
export { ForwardRef as ReactComponent };